<template>
    <div id="kanban-container">
    <!-- <my-tour v-if="" :steps="steps" name="steps-cadastro-empresas"></my-tour> -->
        <section id="content">
            <!--start container-->
            <div class="container">
                 <TituloPagina titulo="Em andamento" />
                <div class="row">
                    <div class="col s12 m12 l12">
                        <div id="card-panel" class="">
                            <div class="row">
                                <div class="site-canvas" id="app">
                                    <div class="tasker-responsive">
                                          <div id="tasker" class="tasker">
                                            <div class="col s12 m3 l3 mr-1 tasker_column" v-for="(column, key) in kanban.columns" :key="key">
                                              <div class="column_name">
                                                  {{column.name}}<span class="task-count">{{column.tasks.length}}</span>
                                              </div>
                                              <div class="column_tasks">
                                                  <div class="tasker_block" v-for="(task, key2) in column.tasks" :key="key2">
                                                    <router-link :to='getURL(task.pedido_id)'>
                                                      <div class="tasker_task-lead">
                                                          {{task.lead}}
                                                      </div>
                                                      <div class="tasker_task-status">
                                                          <span class="status-image" :class="task.cor"></span>
                                                          {{task.status}}
                                                      </div>
                                                    </router-link>
                                                  </div>
                                              </div>

                                         <!-- <router-link v-if="key === 0" to="/cliente/cadastro" class="add-task">
                                                Novo lead
                                              </router-link> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<style lang="scss">
    @import './Kanban.scss';
</style>

<script>
    import { get, post } from '@/helpers/api';
    import Message from '@/helpers/message';
    import MyTour from '@/components/common/MyTour.vue';
    import TituloPagina from '@/components/common/TituloPagina';
    import { DONO, GERENTE, CORRETOR, MASTER, PARCEIRO } from '@/constants/funcionarioCargo.js';
    import Auth from '@/store/auth';
    import TourHelper from '@/helpers/tour';
    import ConverterHelper from '@/helpers/converter';
    import {
        ESTAGIO_PROSPECCAO,
        ESTAGIO_CHAMADA_TELEFONICA,
        ESTAGIO_PRIMEIRA_VISITA,
        // ESTAGIO_SEGUNDA_VISITA,
        ESTAGIO_NEGOCIACAO,
        ESTAGIO_EM_ESPERA
    } from '@/constants/pedidoEstagio.js';

    export default {
    components: {
            MyTour,
            TituloPagina
        },
    data: () => ({
        kanban: {
            columns: []
        },
    }),
    created() {
          let self = this;
          post('pedido/meus-pedidos', {page_qtd: 500}).then(function (response) {
            const pedidos = response.data.result.data.data;


            let tasks_estagio_indicacao =  {
                id: ESTAGIO_PROSPECCAO,
                name: 'Prospecção',
                tasks : []
            };

            let tasks_estagio_contato =   {
                id: ESTAGIO_CHAMADA_TELEFONICA,
                name: 'Chamada Telefônica',
                tasks: []
            };


            let tasks_estagio_visita = {
                id: ESTAGIO_PRIMEIRA_VISITA,
                name: 'Primeira Visita',
                tasks : []
            };

            let tasks_estagio_negociacao =  {
                id: ESTAGIO_NEGOCIACAO,
                name: 'Negociação',
                tasks : []
            }

            let tasks_estagio_cold =  {
                id: ESTAGIO_EM_ESPERA,
                name: 'Em espera',
                tasks : []
            }


            pedidos.forEach(pedido =>{

              if(pedido.pedido_historico.pedido_estagio_id == ESTAGIO_PROSPECCAO){
                tasks_estagio_indicacao.tasks.push({
                      pedido_id: pedido.pedido_id,
                      lead: pedido.cliente_has_produto.cliente.pessoa.pessoa_nome,
                      status: `Indicação do dia ${self.getData(pedido.data_criacao)}`,
                      cor: ConverterHelper.getCoresEsteira(pedido.pedido_historico.pedido_estagio_id)
                  })
              }
              else if(pedido.pedido_historico.pedido_estagio_id == ESTAGIO_CHAMADA_TELEFONICA){
                tasks_estagio_contato.tasks.push({
                      pedido_id: pedido.pedido_id,
                      lead: pedido.cliente_has_produto.cliente.pessoa.pessoa_nome,
                      status: `${ConverterHelper.getContatoTipo(pedido.pedido_historico)} - ${ConverterHelper.getContatoStatus(pedido.pedido_historico.pedido_contato_estado_id)}`,
                      cor: ConverterHelper.getCoresEsteira(pedido.pedido_historico.pedido_estagio_id)
                  })
              }
              else if(pedido.pedido_historico.pedido_estagio_id == ESTAGIO_PRIMEIRA_VISITA){

                if(pedido.pedido_historico.pedido_visita_tipo){
                    tasks_estagio_visita.tasks.push({
                        pedido_id: pedido.pedido_id,
                        lead: pedido.cliente_has_produto.cliente.pessoa.pessoa_nome,
                        status: `${pedido.pedido_historico.pedido_visita_tipo} - ${ConverterHelper.getVisitaStatus(pedido.pedido_historico.pedido_visita_estado_id)}`,
                        cor: ConverterHelper.getCoresEsteira(pedido.pedido_historico.pedido_estagio_id)
                    })

                 }else if(pedido.pedido_historico.pedido_contato_tipo){
                    tasks_estagio_visita.tasks.push({
                        pedido_id: pedido.pedido_id,
                        lead: pedido.cliente_has_produto.cliente.pessoa.pessoa_nome,
                        status: `${pedido.pedido_historico.pedido_contato_tipo} - ${ConverterHelper.getContatoStatus(pedido.pedido_historico.pedido_contato_estado_id)}`,
                        cor: ConverterHelper.getCoresEsteira(pedido.pedido_historico.pedido_estagio_id)
                     })
                }
                else{
                    tasks_estagio_visita.tasks.push({
                        pedido_id: pedido.pedido_id,
                        lead: pedido.cliente_has_produto.cliente.pessoa.pessoa_nome,
                        status: `${pedido.pedido_historico.pedido_historico_comentario}`,
                        cor: ConverterHelper.getCoresEsteira(pedido.pedido_historico.pedido_estagio_id)
                     })
                }

              }
              else if(pedido.pedido_historico.pedido_estagio_id == ESTAGIO_NEGOCIACAO){
                tasks_estagio_negociacao.tasks.push({
                      pedido_id: pedido.pedido_id,
                      lead: pedido.cliente_has_produto.cliente.pessoa.pessoa_nome,
                      status: `${pedido.pedido_historico.pedido_estagio.pedido_estagio_nome}`,
                      cor: ConverterHelper.getCoresEsteira(pedido.pedido_historico.pedido_estagio_id)
                  })
              }
              else if(pedido.pedido_historico.pedido_estagio_id == ESTAGIO_EM_ESPERA){
                tasks_estagio_cold.tasks.push({
                      pedido_id: pedido.pedido_id,
                      lead: pedido.cliente_has_produto.cliente.pessoa.pessoa_nome,
                      status: `Em espera até dia ${self.getData(pedido.pedido_historico.pedido_cold_data_retorno)}`,
                      cor: ConverterHelper.getCoresEsteira(pedido.pedido_historico.pedido_estagio_id)
                  })
              }
            })
            // console.log(pedidos);
            self.kanban.columns = [tasks_estagio_indicacao,tasks_estagio_contato ,tasks_estagio_visita, tasks_estagio_negociacao, tasks_estagio_cold];
          });
      },
    methods: {
      getURL(id){
        return `/lead-gerenciamento/${id}`;
      },
      getData(data) {
        return moment(data).format('DD/MM/YYYY');
      }
    },

    }
</script>



// WEBPACK FOOTER //
// src/components/kanban/Kanban.vue